<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-4"><a href="#/OEBPS/Burgundy_Twisted_Roots2#Contents-A">Dedication</a></p>
<p class="body-center"><em class="italic">For my granddaughter, <br class="calibre1"/>Camille Aurora Katharine Brown</em></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Burgundy_Twisted_Roots3.vue?a8bf65b6